import request from '@/middleware/request'

const getListInsight = () => {
  return request({
    url: '/insight/list_insight',
    method: 'get'
  })
}

const getJourney = data => {
  return request({
    url: '/insight/journey',
    method: 'post',
    data
  })
}

const countQc = data => {
  return request({
    url: '/insight/count_qc',
    method: 'post',
    data
  })
}
const getValidSpeech = data => {
  return request({
    url: '/insight/valid_speech',
    method: 'post',
    data
  })
}
const getSamplingScope = data => {
  return request({
    url: '/insight/sampling_scope',
    method: 'post',
    data
  })
}
const getWordAccuracy = data => {
  return request({
    url: '/insight/word_accuracy',
    method: 'post',
    data
  })
}
const getQcPersons = data => {
  return request({
    url: '/insight/qc_persons',
    method: 'post',
    data
  })
}
const getIntentAccuracy = data => {
  return request({
    url: '/insight/intent_accuracy',
    method: 'post',
    data
  })
}

const getCheckpoint = data => {
  return request({
    url: '/insight/checkpoint',
    method: 'post',
    data
  })
}

const exportExcel = (name, data) => {
  return request({
    url: `/insight/export/excel/${name}`,
    method: 'post',
    responseType: 'blob',
    data
  })
}

const exportPdf = (name, data) => {
  return request({
    url: `/insight/export/pdf/${name}`,
    method: 'post',
    responseType: 'blob',
    data
  })
}

const exportCsv = (name, data) => {
  return request({
    url: `/insight/export/csv/${name}`,
    method: 'post',
    responseType: 'blob',
    data
  })
}

export default {
  getListInsight,
  getJourney,

  countQc,
  getValidSpeech,
  getSamplingScope,
  getWordAccuracy,
  getQcPersons,
  getIntentAccuracy,

  getCheckpoint,

  exportExcel,
  exportPdf,
  exportCsv
}
